import React from "react";
import styles from "./Timeline.css";
import Bio from "../Bio";
const events = [
  {
    id: 3,
    // title: "Event 3",
    description:
      "حاصل على درجة الدكتوراه في الإدارة من جامعة اليرموك -المملكة الاردنية الهاشمية ",
    year: 2006, // add the year property
  },
  {
    id: 2,
    // title: "Event 2",
    description:
      "حاصل على درجة الماجستير في العلوم السياسية -بتقدير امتياز من جامعة سيركيوز _امريكا ",
    year: 1998, // add the year property
  },
  {
    id: 1,
    // title: "",
    description:
      "حاصل على شهادة البكالوريوس في العلوم السياسية من جامعة سيركيوز -امريكا",
    // year: 2022, // add the year property
  },
];

function Timeline() {
  return (
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <h6 class="card-title" className="text-center display-4 my-3">
                السيرة الذاتية
              </h6>
              <div id="content">
                <ul class="timeline">
                  {events.map((event) => {
                    return (
                      <li class="event" data-date={event.year}>
                        <h3>{event.title}</h3>
                        <p
                          style={{
                            textAlign: "right",
                          }}
                        >
                          {event.description}
                        </p>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Bio />
    </div>
  );
}

export default Timeline;
